// Utilities for GI Planning state filtering and display mapping

const KNOWN_STATES = ['Animé', 'Annulé', 'En attente'];

export const normalizePlanningState = (state) => state || '__EMPTY__';

const isStateSelected = (state, selectedStates) => {
  if (!selectedStates || selectedStates.length === 0) return true;

  const normalizedState = normalizePlanningState(state);

  if (KNOWN_STATES.includes(normalizedState)) {
    return selectedStates.includes(normalizedState);
  }

  return selectedStates.includes('Autre');
};

export const getPlanningTimeslots = (item) => {
  if (Array.isArray(item?.Timeslots) && item.Timeslots.length > 0) {
    return item.Timeslots.map((timeslot) => ({
      ...timeslot,
      PromoterId: timeslot.PromoterId ?? item.PromoterId ?? null,
      State: timeslot.State ?? item.State ?? null,
      StateId: timeslot.StateId ?? item.StateId ?? null,
    }));
  }

  if (
    item?.PromoterId ||
    item?.State ||
    item?.StateId ||
    item?.StartTime ||
    item?.EndTime
  ) {
    return [{
      StartTime: item.StartTime || null,
      EndTime: item.EndTime || null,
      PromoterId: item.PromoterId ?? null,
      State: item.State ?? null,
      StateId: item.StateId ?? null,
    }];
  }

  return [];
};

export const getFilteredTimeslots = (item, selectedStates = []) => (
  getPlanningTimeslots(item).filter((timeslot) => isStateSelected(timeslot.State, selectedStates))
);

export const getPlanningItemPromoterIds = (item, selectedStates = []) => (
  [...new Set(
    getFilteredTimeslots(item, selectedStates)
      .map((timeslot) => timeslot.PromoterId)
      .filter(Boolean)
  )]
);

export const getPlanningItemStates = (item, selectedStates = []) => (
  getFilteredTimeslots(item, selectedStates).map((timeslot) => normalizePlanningState(timeslot.State))
);

// Filter planning items by selected states
export const applyStateFilter = (planningItems, selectedStates) => {
  if (!Array.isArray(planningItems) || planningItems.length === 0) return [];
  if (!selectedStates || selectedStates.length === 0) return planningItems;

  return planningItems.filter((item) => getFilteredTimeslots(item, selectedStates).length > 0);
};

// Map planning state to icon/color/display
export const getStateIconAndColor = (state) => {
  switch (state) {
    case 'Animé':
      return { icon: '✓', color: 'text-green-600', displayState: state };
    case 'Annulé':
      return { icon: '✗', color: 'text-red-600', displayState: state };
    case 'En attente':
      return { icon: '⏳', color: 'text-yellow-600', displayState: state };
    case null:
    case undefined:
    case '':
    case '__EMPTY__':
      return { icon: '--', color: 'text-gray-600', displayState: 'Non renseigné' };
    default:
      return { icon: '--', color: 'text-gray-600', displayState: state };
  }
};


